module.exports = __webpack_public_path__ + "static/dune-7d514583aa0d6cadd37903397d5724f2.jpg";